<template>
  <v-dialog v-model="inviteDialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn right class="my-4 mr-4" color="primary" v-on="on">
        <v-icon left>mdi-plus</v-icon>Company
      </v-btn>
    </template>
    <v-card v-if="!finished">
      <v-card-title class="headline primary white--text" primary-title
        >Create a new company</v-card-title
      >

      <v-card-text class="mt-2">
        <v-text-field v-model="companyName" label="Company Name"></v-text-field>
        Company owner email:
        <v-text-field
          v-model="inviteEmail"
          label="E-mail"
          hint="An email will be sent to accept the invitation"
        ></v-text-field>
        <p class="red--text" v-if="feedback">{{ feedback }}</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog()">Cancel</v-btn>
        <v-btn color="primary" :loading="isInviting" @click="inviteUser()">Create</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline primary white--text" primary-title>Success</v-card-title>
      <v-card-text class="mt-2"
        >{{ companyName }} was succesfully created and an invite email was sent to
        {{ inviteEmail }}</v-card-text
      >
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from "firebase/app";
import "firebase/functions";

export default {
  name: "NewCompany",
  data() {
    return {
      inviteDialog: false,
      isInviting: false,
      inviteEmail: "",
      companyName: "",
      feedback: null,
      finished: false,
    };
  },
  methods: {
    closeDialog() {
      this.inviteDialog = false;
      this.finished = false;
      this.inviteEmail = "";
      this.isInviting = false;
    },
    inviteUser() {
      console.log("inviting user:", this.inviteEmail);
      const isEmailValid = /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}/.test(
        this.inviteEmail,
      );

      if (!isEmailValid) {
        this.feedback = "Please provide a valid email";
        return;
      }

      this.feedback = null;
      // const company = this.$store.state.company;
      this.isInviting = true;
      const createCompany = firebase.functions().httpsCallable("company-adminCreateCompany");
      createCompany({
        inviteEmail: this.inviteEmail,
        companyName: this.companyName,
      })
        .then((result) => {
          console.log(result);
          this.isInviting = false;
          this.finished = true;
        })
        .catch((error) => {
          const { message } = error;
          this.isInviting = false;
          this.feedback = message;
        });
    },
  },
};
</script>
